module.exports = __webpack_public_path__ + "assets/img/位图@2x(1).e58c5121.png";